export default "__VITE_ASSET__05ce4443__"